<template>

  <div v-if="$store.state.isEnhanced" class="e_view">
    <div class="right_panel">
      <ul class="tabs">
        <li :class="{active: isActive('article-detail')}"><a @click="navigateTo('article-detail')">Article</a></li>
        <li :class="{active: isActive('article-detail-authors')}"><a @click="navigateTo('article-detail-authors')">Authors</a></li>
        <li :class="{active: isActive('article-detail-related')}"><a @click="navigateTo('article-detail-related')">Related</a></li>
      </ul>

      <slot name="anchors"></slot>
      <slot name="keywords"></slot>
      <slot name="authors"></slot>
      <slot name="current_article"></slot>
    </div>
    <div class="content">
      <slot name="title"></slot>
      <slot name="full_text"></slot>
      <slot></slot>
    </div>
  </div>

  <div v-else class="d_view">
    <div class="row">
      <div class="col-md-8">
        <slot name="title"></slot>
      </div>
      <div class="col-md-4">
        <slot name="bar"></slot>
      </div>
    </div>
    <ul class="tabs hidden-sm-down">
      <li v-for="option in options" :class="{active: isActive(option.value)}"><a @click="navigateTo(option.value)">{{option.text}}</a></li>
      <li><a @click="toggleToEnhanced">Enhanced View</a></li>
    </ul>
    <b-form-select v-model="selected" :options="options" @input="navigateTo(selected)" class="hidden-md-up"></b-form-select>

    <div class="row">
      <div class="col-md-4 col-lg-3 hidden-sm-down">
        <div class="articleAnchors" id="articleAnchors"><slot name="anchors"></slot></div>
      </div>
      <div class="col-md-8 col-lg-9 article-content">
        <resize-observer @notify="handleResize" />
        <slot name="full_text"></slot>
      </div>
    </div>
    <slot></slot>

    <b-modal id="navModal" title="Jump To" :hide-footer=true>
      <div class="anchors">
        <div v-for="(value, key) in modalAnchors">
          <a :class="{active: $route.hash == ('#'+key) || (key == 'Abstract' && !$route.hash)}"
             @click="jumpTo(key)">
            {{ value }}
          </a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'articleDetailComponent',
    data () {
      return {
        modalAnchors: {},
        options: [
          {value: 'article-detail', text: 'Article'},
          {value: 'article-detail-authors', text: 'Authors'},
          {value: 'article-data', text: 'Data'},
          {value: 'article-metrics', text: 'Metric'},
          {value: 'article-detail-related', text: 'Related'}
        ],
        selected: this.$route.name,
        scrolled: false
      }
    },
    mounted () {
      this.$root.$once('show::modal', this.openNavModal)
      window.addEventListener('scroll', this.handleScroll)
      if (this.$route.hash && this.$el.querySelector(this.$route.hash)) {
        window.scroll(0, this.$el.querySelector(this.$route.hash).getBoundingClientRect().top)
      }
    },
    destroyed () {
      this.$root.$off('show::modal', this.openNavModal)
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      isActive (routeName) {
        return this.$route.name === routeName
      },
      navigateTo (name) {
        this.$parent.$parent.$el.classList.remove('transition-top', 'transition-bottom', 'transition-left')
        this.$parent.$parent.$el.classList.add('transition-right')
        this.$router.push({name: name})
        if (this.$store.state.isEnhanced) {
          setTimeout(this.$parent.$parent.$parent.toggleHeader.bind(this.$parent.$parent.$parent), 1000)
        }
      },
      toggleToEnhanced () {
        this.$store.commit('setMode', true)
        if (this.$route.name === 'article-data') {
          if (this.$route.hash === '#Videos') {
            this.$router.push({name: 'article-interact-video', params: this.$route.params})
          } else if (this.$route.hash === '#Figures') {
            this.$router.push({name: 'article-interact-figures', params: this.$route.params})
          } else {
            this.$router.push({name: 'article-interact-tables', params: this.$route.params})
          }
        }
      },
      openNavModal (modalName, anchors) {
        if (modalName !== 'navModal') {
          return
        }
        this.modalAnchors = anchors
      },
      jumpTo (key) {
        this.$root.$emit('hide::modal', 'navModal')
        location.hash = key
      },
      handleScroll () {
        if (!this.$store.state.isEnhanced) {
          let articleAnchors = document.getElementById('articleAnchors')
          let articleAnchorsParent = articleAnchors.parentElement
          let scrollPosition = articleAnchors ? (parseInt(articleAnchorsParent.offsetTop)) : 0

          // 135 -> Heder.height - #navWrapper.height
          // 60 -> #navWrapper.height + 10
          // 420 -> footer.height + 10
          this.scrolled = window.scrollY > (scrollPosition + 135)

          articleAnchors.style.width = (articleAnchorsParent.offsetWidth - 30) + 'px'
          if (this.scrolled && (window.scrollY + articleAnchors.offsetHeight + 10 + 420) > (document.documentElement.scrollHeight || document.body.scrollHeight)) {
            articleAnchors.style.top = 'auto'
            articleAnchors.style.bottom = 20 + 'px'
            articleAnchors.style.position = 'absolute'
          } else if (this.scrolled) {
            articleAnchors.style.bottom = 'auto'
            articleAnchors.style.top = 60 + 'px'
            articleAnchors.style.position = 'fixed'
          } else {
            articleAnchors.style.position = 'static'
          }
        }
        this.highlightSection()
      },
      handleResize () {
        this.handleScroll()
      },
      highlightSection () {
        let currentSection = false
        this.$el.querySelectorAll('section h1[id]').forEach(function (el) {
          if (el.getBoundingClientRect().top <= 0) {
            currentSection = el.id
          } else if (!currentSection && el.getBoundingClientRect().top < (document.documentElement.clientHeight || document.body.clientHeight)) {
            currentSection = el.id
            return false
          }
        })
        this.$parent.currentSection = currentSection
      }
    }
  }
</script>


<style lang="scss" scoped>
  .right_panel {
    position: fixed;
    right: 50px;
    width: 280px;
  }
  .floated {
    @media (min-width: $breakpoint-md) and (max-width: $breakpoint-lg) {
      margin-right: calc(15px - 33.33vw);
    }
    @media (min-width: $breakpoint-lg) and (max-width: $breakpoint-xl){
      margin-right: calc(990px/-3 + 15px);
    }
    @media (min-width: $breakpoint-xl){
      margin-right: calc(1220px/-3 + 15px);
    }
  }
  .tabs {
    list-style: none;
    overflow: hidden;
    padding: 0;
    height: 36px;
    margin-bottom: 3px;
    position: relative;
    z-index: 1;
    a {
      float: left;
      background: #eee;
      padding: 0 15px;
      text-decoration: none;
      height: 36px;
      text-align: center;
      border-left: 1px solid $white;
      line-height: 36px;
      border-bottom: 3px solid #eee;
      white-space: nowrap;
      cursor: pointer;
    }
    .active a {
      border-bottom: 3px solid $secondary-color;
      cursor: default;
    }
  }
  .tabs + select {
    margin-bottom: 2.5rem !important;
    width: 100%;
  }

  .has-header .right_panel   {
    top: auto;
  }
  .content {
    margin-right: 300px;
    padding: 0 10px;
    .issue:first-child {
      margin-top: 10px;
    }
  }

  .d_view .tabs {
    li a {
      width: 16%;
    }
    li:last-child a{
      width: 20%;
      background-color: #333;
      color: $white !important;
      border-bottom: none;
    }
  }
  .e_view .tabs a {
    width: 33.333%;
  }
</style>



// WEBPACK FOOTER //
// ArticleDetailComponent.vue?3f4bfae2